export function normalizeBookInfo(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    throw new TypeError("Book data must be a JSON object.");
  }
  const pages = value.pageArray;
  const hasPages = Array.isArray(pages)
    ? pages.length > 0
    : pages !== null &&
      typeof pages === "object" &&
      Object.keys(pages).length > 0;

  if (!hasPages) {
    throw new TypeError("Book data must contain at least one page.");
  }
  if (typeof value.path !== "string" || value.path.length === 0) {
    throw new TypeError("Book data must contain a page path.");
  }

  return {
    ...value,
    toc: Array.isArray(value.toc) ? value.toc : [],
  };
}

export async function readBookInfo(element, documentRoot = document) {
  if (!element.id) {
    throw new TypeError("A book element needs an id to locate its JSON data.");
  }

  const dataElement = documentRoot.getElementById(`${element.id}-data`);
  const embeddedJson = dataElement?.textContent.trim();
  if (!embeddedJson) {
    throw new TypeError(`Missing JSON data for book "${element.id}".`);
  }

  let value;
  try {
    value = JSON.parse(embeddedJson);
  } catch (error) {
    throw new TypeError(`Invalid JSON data for book "${element.id}".`, {
      cause: error,
    });
  }

  return normalizeBookInfo(value);
}
